import * as React from 'react';
import { CoreProps } from '../types';

interface FontProps extends CoreProps {
    as?: keyof JSX.IntrinsicElements;
    style?: {
        [key: string]: string;
    };
    desktop?: string;
    mobile?: string;
    color?: string | undefined;
    noTranslate?: boolean;
}

export const Font = (props: FontProps) => {
    const { as: Tag = 'p', className, composeClassName, mobile, desktop, children, color, noTranslate, ...rest } = props;
    const mobileFontSize = mobile ? `font-${mobile}` : undefined;
    const desktopFontSize = desktop ? `font-d-${desktop}` : undefined;

    const tagClassNames = [mobileFontSize, desktopFontSize, composeClassName, className].filter(Boolean).join(' ');

    return (
        <Tag className={tagClassNames + (noTranslate ? ' notranslate' : '')} style={{ color: color }} translate={noTranslate ? 'no' : undefined} {...rest}>
            {children}
        </Tag>
    );
};

// FONTS

// Futura Light
Font.FuturaLight = (props: FontProps) => <Font {...props} composeClassName="futura-light" />;

// Futura Medium
Font.FuturaMedium = (props: FontProps) => <Font {...props} composeClassName="futura-medium" />;

// Futura Book
Font.FuturaBook = (props: FontProps) => <Font {...props} composeClassName="futura-book" />;

// Futura Heavy
Font.FuturaHeavy = (props: FontProps) => <Font {...props} composeClassName="futura-heavy" />;

// Futura Bold
Font.FuturaBold = (props: FontProps) => <Font {...props} composeClassName="futura-bold" />;

// Oxanium Light
Font.OxaniumLight = (props: FontProps) => <Font {...props} composeClassName="font-oxanium-light" />;

// Oxanium Regular
Font.OxaniumRegular = (props: FontProps) => <Font {...props} composeClassName="font-oxanium-regular" />;

// Oxanium Medium
Font.OxaniumMedium = (props: FontProps) => <Font {...props} composeClassName="font-oxanium-medium" />;

// Oxanium Bold
Font.OxaniumBold = (props: FontProps) => <Font {...props} composeClassName="font-oxanium-bold" />;

// --------------------------------------------------------

// Special Font Elements

const { FuturaLight, FuturaMedium, FuturaBook } = Font;

// Section Heading
Font.Heading = (props: FontProps) => (
    <FuturaMedium mobile="22" desktop="32" {...props} className="lh-32 lh-d-48 font-center font-uppercase mob_pad font-heading-base" />
);

// Section Subheading
Font.Subheading = (props: FontProps) => <FuturaLight mobile="20" desktop="30" {...props} className="lh-34 lh-d-30 font-center mob_pad font-subheading-base" />;

Font.Summary = (props: FontProps) => <FuturaBook mobile="18" desktop="18" {...props} className="lh-28 lh-d-28 font-center mob_pad font-summary-base" />;

// --------------------------------------------------------
//
// TYPES

type Fonts = typeof Font | typeof Font.FuturaLight | typeof Font.FuturaMedium | typeof Font.FuturaBook | typeof Font.FuturaHeavy | typeof Font.FuturaBold;

// --------------------------------------------------------
//
// EFFECTS

export const addBlend = (Element: Fonts) => (props: FontProps) => <Element {...props} className="has-blend" />;

export const addTrace = (Element: Fonts) => (props: FontProps) => <Element {...props} className="font-traced" />;

// -----------------------------------------------------------------------------------------------------------------
